import type { SVGProps } from 'react';
const SvgLabelImportantOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#label_important_outline_svg__a)">
      <path
        fill="currentColor"
        d="M15 19H3l4.5-7L3 5h12c.65 0 1.26.31 1.63.84L21 12l-4.37 6.16c-.37.52-.98.84-1.63.84Zm-8.5-2H15l3.5-5L15 7H6.5l3.5 5-3.5 5Z"
      />
    </g>
    <defs>
      <clipPath id="label_important_outline_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLabelImportantOutline;
